export const BeliefInFresh = {
  FRESH_IS_BEST: 4,
  FRESH_IS_GOOD: 3,
  NOT_SURE: 2,
  NO_TO_FRESH: 1,
} as const;

export type TBeliefInFreshValues = (typeof BeliefInFresh)[keyof typeof BeliefInFresh];

export const NumberOfTreats = {
  LOTS: "lots",
  SOME: "some",
  FEW: "few",
  NONE: "none",
} as const;

export type TNumberOfTreatsValues = (typeof NumberOfTreats)[keyof typeof NumberOfTreats];

export const Persona = {
  INGREDIENT_INVESTIGATOR: "INGREDIENT_INVESTIGATOR",
  VET_GUIDED_CAREGIVER: "VET_GUIDED_CAREGIVER",
  INDULGENT_OWNER: "INDULGENT_OWNER",
  VALUE_MAINSTREAMER: "VALUE_MAINSTREAMER",
  SUBSCRIPTION_SEEKER: "SUBSCRIPTION_SEEKER",
  CASUAL_CAT_OWNER: "CASUAL_CAT_OWNER",
} as const;

export type TPersonaValues = (typeof Persona)[keyof typeof Persona];

export interface IFreshCustomerSUFAnswers {
  /** A value indicating the customer's belief in the benefits of fresh cat food. */
  beliefInFresh?: TBeliefInFreshValues | null;
  /** How many treats the customer gives to their cat. */
  numberOfTreats?: TNumberOfTreatsValues | null;
  /** Why the customer is trying KatKin.
   * Must be an array of strings.
   * No duplicates are allowed.
   * No empty arrays are allowed. */
  switchReasons?: string[] | null;
  /** Primary reasons for switching to KatKin for each cat.
   * Must be an array of strings.
   * No duplicates are allowed.
   * No empty arrays are allowed. */
  primarySwitchReason?: string[] | null;
  /** Secondary reasons for switching to KatKin for each cat.
   * Must be an array of strings.
   * No duplicates are allowed.
   * No empty arrays are allowed. */
  secondarySwitchReasons?: string[] | null;
  /** The customer's persona, derived from the SUF persona question. */
  persona?: TPersonaValues | null;
}
